const relatedColumnStyles = (theme) => ({
  entityRelated: {
    // backgroundColor: "#eaf0f2",
    // color: "#212121",
    // fontSize: "13px",
    // lineHeight: "24px",
    padding: '10px 15px 0',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    overflowY: 'auto',
    boxShadow: 'inset 0 1px 3.5px 0 rgba(0,0,0,0.12)',
  },
});

export default relatedColumnStyles;
